<template>
    <div class="page">
        <!-- <h4 class="active-reservation">Active Reservations</h4> -->
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <div v-if="reservationInd" class="container">
                <div class="card">
                    <h4>No Active Reservations</h4>
                    <p>Your reservation list is currently empty.</p>

                    <!-- <ion-button class="btn-res" expand="block" @click="addReservatin">
                        Make Reservation
                    </ion-button> -->
                </div>
            </div>
            <div v-else>
                <ion-row class="search-view">
                    <ion-col>
                        <ion-row class= "ion-align-items-stretch" >
                            <ion-col size="12" size-md="1">
                                <ion-label>Status</ion-label>
                            </ion-col>

                            <ion-col size="12" size-md="3">
                                <div class="border-line-34 ">
                                    <ion-select
                                        class="form-select select-mobile"
                                        :value="status"
                                        @ionChange="status = $event.target.value"
                                        placeholder="Select Status"
                                        interface="action-sheet"
                                        >
                                        <ion-select-option
                                            v-for="(status, index) in this.statuses"
                                            :key="index"
                                            :value="status.id"
                                        >{{status.name}}</ion-select-option>
                                    </ion-select>

                                    <select
                                        class="input-select select-web"
                                        v-model="status"
                                        placeholder="Select Status"
                                        >
                                        <option
                                            v-for="(status, index) in this.statuses"
                                            :key="index"
                                            :value="status.id"
                                        >{{ status.name }}</option>
                                    </select>
                                </div>
                            </ion-col>

                            <ion-col size="12" size-md="3">
                                <ion-button class="btn-search " @click="searchReservations">Apply</ion-button>
                                <ion-button class="btn-clear " @click="clearFields">
                                    <ion-icon :icon="refresh"></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
                <ion-row class="row-divider"></ion-row>
                <ion-row class= "ion-align-items-stretch" >
                    <ion-col
                    size="12"
                    size-md="6"
                    v-for="(reservation) in this.reservations"
                    :key="reservation"
                    >
                        <ion-card @click="viewReservation(reservation.id)">
                            <ion-card-content class="vh-content">
                                <ion-row>
                                    <ion-col class="ion-text-left" size="6">
                                    <ion-label class="book-ref">{{reservation.refNo}}</ion-label>
                                    <br />
                                    <span class="vh-name">
                                        <img
                                        v-if="reservation.vehicle.type.id === 'TW'"
                                        class="vh-icon"
                                        src="/assets/images/vehicles/335024.png"
                                        />
                                        <img
                                        v-if="reservation.vehicle.type.id == 'FW'"
                                        class="vh-icon"
                                        src="/assets/images/vehicles/846338.png"
                                        />
                                        <img
                                        v-if="reservation.vehicle.type.id == '3W'"
                                        class="vh-icon"
                                        src="/assets/images/vehicles/rickshaw.png"
                                        />
                                        <img
                                        v-if="reservation.vehicle.type.id == 'BUS'"
                                        class="vh-icon"
                                        src="/assets/images/vehicles/bus.png"
                                        />
                                        <img
                                        v-if="reservation.vehicle.type.id == 'TRUCK'"
                                        class="vh-icon"
                                        src="/assets/images/vehicles/truck.png"
                                        />
                                        {{reservation.vehicle.regNo}}
                                    </span>
                                    <!-- <br /> -->
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <ion-label
                                        class="vh-model"
                                    >{{reservation.vehicle.make.name}}&nbsp;{{reservation.vehicle.model.name}}</ion-label>
                                    </ion-col>
                                    <ion-col class="ion-text-right" size="6">
                                    <!-- <ion-label
                                        class="book-time"
                                    >{{reservation.slot.startsOn | dateFormat('hh:MM A')}} - {{reservation.slot.endsOn | dateFormat('hh:MM A')}}</ion-label>
                                    <br />-->
                                    <ion-label class="book-day">
                                        {{changeDateFormat(reservation.slot.startsOn)}}
                                        <!-- <br />
                                        {{changeDateFormat(reservation.slot.endsOn)}} -->
                                    </ion-label>
                                    </ion-col>
                                </ion-row>
                                <hr />
                                <ion-row>
                                    <ion-col class="ion-text-left" size="8">
                                    <ion-label class="book-station">{{reservation.station.name}}&nbsp;<br /><span v-if="reservation.station.rating != 0">{{reservation.station.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></ion-label>
                                    <br />
                                    <ion-label
                                        class="book-location"
                                    >{{reservation.station.address.line1}}, {{reservation.station.address.city}}</ion-label>
                                    <br />
                                    <div class="call-options" v-if="reservation.status.id === 'O'">
                                        <a v-bind:href="'tel:' + reservation.station.mobile" class="call-img-a">
                                        <img class="call-img" src="../../assets/card-call.png" />
                                        </a>
                                        <img
                                        class="map-img"
                                        src="../../assets/card-map.png"
                                        @click="googleMapApp(reservation.station.coordinate)"
                                        />
                                    </div>
                                    </ion-col>
                                    <ion-col size="4" class="ion-text-right">
                                        <ion-label v-if="reservation.status.id === 'C'"
                                            class="book-amount"
                                        >&#8377; {{(reservation.commercial.actual ? reservation.commercial.actual.nettCost : reservation.commercial.estimated.nettCost)}}</ion-label>
                                        <br />
                                        <ion-label
                                            class="status-medium-rc"
                                            v-bind:class="[{'open': reservation.status.id === 'O'}, {'cancelled': reservation.status.id === 'X'}, {'wip': reservation.status.id === 'P'}, {'expired': reservation.status.id === 'E'}, {'completed': reservation.status.id === 'C'}, {'ierr': reservation.status.id === 'I'}]"
                                        >{{reservation.status.name}}</ion-label>
                                        <p class="select-web unavailable" v-if="reservation.gun.setup.charger.status.remarks === 'UN'">{{reservation.gun.setup.charger.status.additionalinfo}}</p>
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-no-margin ion-no-padding select-mobile unavailable" v-if="reservation.gun.setup.charger.status.remarks === 'UN'">
                                    <ion-col class="ion-no-margin ion-no-padding">
                                    <label>{{reservation.gun.setup.charger.status.additionalinfo}}</label>
                                    </ion-col>
                                </ion-row>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </div>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonButton, IonIcon, IonCard, IonCardContent, IonSpinner } from "@ionic/vue";
import { refresh, star } from 'ionicons/icons';
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { EVChargingReservationStatus } from "@/entity/station/reservation";
import { migratedTryParseServiceError } from "../../service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import moment from 'moment';

export default defineComponent ({
    name: 'myReservations',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonButton, IonIcon, IonCard, IonCardContent, IonSpinner
    },
    data() {
        return {
            refresh,
            star,
            loaderTab: true,
            statuses: [],
            reservations: null,
            status: "",
            reservationInd: false
        }
    },
    async mounted() {
        try {
            let user = new LocalStorage().user;
            localStorage.removeItem("editReservationDetails");
            localStorage.removeItem("editReservationPage");
            this.statuses = await new EVCStationReservationService().reservationStatuses();
            let reservations = await new EVCStationReservationService().reservationsReservedByUser(
                user,
                this.status ? new EVChargingReservationStatus(this.status, "") : null,
                1,
                100
            );
            if (reservations && reservations.length > 0) {
                this.reservations = reservations;
                this.reservationInd = false
                } else {
                this.reservationInd = true
            }
            this.loaderTab = false;
        } catch(error) {
            this.loaderTab = false;
            // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
    },
    methods: {
        addReservatin() {
            this.$router.push('/customer/reservation') 
        },
        changeDateFormat(dateValue) {
            return moment(dateValue).format('DD/MMM/YYYY HH:mm')
        },
        googleMapApp(coordinate) {
            if (
                /* if we're on iOS, open in Apple Maps */
                navigator.platform.indexOf("iPhone") != -1 ||
                navigator.platform.indexOf("iPod") != -1 ||
                navigator.platform.indexOf("iPad") != -1
            )
                window.open(
                "maps://maps.google.com/maps?daddr=" +
                    coordinate.latitude +
                    "," +
                    coordinate.longitude +
                    "&amp;ll="
                );
            /* else use Google */ else
                window.open(
                "https://maps.google.com/maps?daddr=" +
                    coordinate.latitude +
                    "," +
                    coordinate.longitude +
                    "&amp;ll="
                );
        },
        async searchReservations() {
            try {
                this.loaderTab = true;
                let user = new LocalStorage().user;
                this.reservations = await new EVCStationReservationService().reservationsReservedByUser(
                    user,
                    this.status ? new EVChargingReservationStatus(this.status, "") : null,
                    1,
                    100
                );
                this.loaderTab = false;
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
           
        },
        async clearFields() {
            try {
                this.loaderTab = true;
                this.status = null;
                let user = new LocalStorage().user;
                this.reservations = await new EVCStationReservationService().reservationsReservedByUser(
                    user,
                    null,
                    1,
                    100
                );
                this.loaderTab = false;
            }  catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },
        viewReservation(bookingId) {
            this.$router.push({
                name: "myReservationView",
                params: { bookingId: bookingId },
            });
        },
    },
})
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.card {
  width: 100%;
  max-width: 320px;
  padding: 25px 20px;
  border-radius: 16px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}


.card h3 {
  margin-bottom: 10px;
  font-weight: 600;
}

.card p {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.btn-res {
    --background: #21B24B;
  --border-radius: 12px;
}
.active-reservation {
  margin-top: 0px;
  padding: 5px;
  height: 37px;
  background: #fafafa 0% 0% no-repeat padding-box;
  border: 1px solid #e9e9e9;

  line-height: 28px;
  text-align: left;
  font-family: "Roboto Bold";
  font-size: 14px;
  letter-spacing: 0;
  color: #21b24b;
  opacity: 1;
}
.past-reservation {
  margin-top: 0px;
  padding: 5px;
  height: 37px;
  background: #e9e9e9 0% 0% no-repeat padding-box;
  border: 1px solid #e9e9e9;

  line-height: 28px;
  text-align: left;
  font-family: "Roboto Bold";
  font-size: 14px;
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
}
.rectangle {
  padding: 0px !important;
}
ion-card {
  /* height: 84px; */
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  cursor: pointer;
}
.vh-name {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #313131;
  opacity: 1;
}
.vh-icon {
  height: 17px;
  width: 33px;
  vertical-align: middle;
  display: inline-block;
  clear: left;
}
.vh-model {
  text-align: left;
  font-family: "Roboto";
  font-size: 15px;
  letter-spacing: 0;
  color: #313131;
  opacity: 0.75;
}

.book-time {
  text-align: right;
  font-family: "Roboto";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}

.book-ref {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #041648;
  opacity: 1;
}

.book-day {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}

.book-station {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  letter-spacing: 0;
  color: #414141;
  opacity: 1;
}

.book-location {
  text-align: left;
  font-family: "Roboto";
  font-size: 15px;
  letter-spacing: 0;
  color: #414141;
  opacity: 1;
}

.book-amount {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  color: #21b24b;
  opacity: 1;
}

.vh-book {
  text-align: left;
  font-family: "Roboto Light";
  font-size: 13px;
  letter-spacing: 0;
  color: #313131;
  opacity: 0.75;
}
.vh-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
}

.call-options {
  display: inline-block;
}

.call-options img.call-img {
  width: 24px;
  height: 24px;
  display: inline-block;
  top: -3px;
}
.call-options a.call-img-a {
  margin-right: 21px;
}

.call-options img.map-img {
  width: 36px;
  height: 36px;
  display: inline-block;
  cursor: pointer;
}
/* Below class is added by vinoth */
.select-web.unavailable {
  color: #d66c6c;
  text-align: right;
  margin-top: 16px;
  font-size: 16px;
  /*font-weight: bold;*/
}
.select-mobile.unavailable {
  padding: 0;
  margin: 0;
  color: #d66c6c;
  text-align: right;
  font-size: 16px;
  /*font-weight: bold;*/
}
</style>